<template>
  <div>
    <section v-if="frsm" class="section">
      <section id="views" class="hero title-card">
        <div class="hero-body has-text-centered">
          <div class="container">
            <h1 class="title">
              Resumen del Resultado de Factores de riesgos psicosociales
            </h1>
            <!-- <h2 class="subtitle">
              Resumen del Resultado de Factores de riesgos psicosociales
            </h2> -->
          </div>
        </div>
      </section>
      <!-- Header of Board -->
      <nav class="level" style="margin-bottom: 4%; margin-top: 4%">
        <div class="level-item has-text-centered">
          <div>
            <p class="heading">Fecha del Diagnóstico</p>
            <p class="title">{{ header.date }}</p>
          </div>
        </div>
        <div class="level-item has-text-centered">
          <div>
            <p class="heading">Encuestados</p>
            <p class="title">{{ header.surveyed }}</p>
          </div>
        </div>
      </nav>

      <!-- Second header of filter and options -->
      <div id="divObserver" class="myObserver"></div>
      <div
        class="is-flex"
        id="divFilters"
        :style="board.filter || board.historic.filter ? 'top: 10px;' : ''"
        style="justify-content: space-between !important; padding: 10px 5px;"
      >
        <div
          class="field is-grouped is-grouped-multiline"
          v-if="board.filter"
          style="width: 100% !important;"
        >
          <!-- Delete Filters -->
          <div class="control" v-if="!board.demo && !this.$route.params.id">
            <div class="tags has-addons">
              <span
                class="tag is-danger"
                style="cursor: pointer"
                v-on:click="deselectFilter"
                ><i class="material-icons">delete_sweep</i></span
              >
            </div>
          </div>
          <!-- Show Filters Board -->
          <div
            class="control"
            v-for="(v, k) in board.filter"
            :key="k + 'board'"
          >
            <div class="tags has-addons">
              <span class="tag is-grey-light">{{ v.gr }}</span>
              <span class="tag is-blue"
                >{{ v.subgr }}
                <button
                  class="delete is-small"
                  v-on:click="deselectOne(v)"
                ></button
              ></span>
            </div>
          </div>

          <div class="control" v-if="board.historic.filter">
            <div class="tags has-addons">
              <span
                class="tag"
                style="margin-left: 5px; margin-right: 5px; background-color: white;"
                ><strong>VS</strong></span
              >
            </div>
          </div>

          <!-- Show Filters Historic -->
          <div
            class="control"
            v-for="(v, k) in board.historic.filter"
            :key="k + 'historic'"
          >
            <div class="tags has-addons">
              <span class="tag is-grey-light">{{ v.gr }}</span>
              <span class="tag is-blue">{{ v.subgr }}</span>
            </div>
          </div>
        </div>

        <div style="width: 100%" v-if="!board.filter"></div>

        <!-- Share -->
        <div
          class="control"
          v-if="!this.$route.params.id"
          style="justify-content: right !important; width: 18% !important; display: flex !important;"
        >
          <div class="tags has-addons">
            <span
              class="tag is-grey-light"
              style="cursor: pointer"
              v-tooltip="'Clic para copiar link'"
              v-on:click="copyLink()"
              >Compartir Tablero</span
            >
            <span class="tag is-link"
              ><i class="material-icons is-size-5">share</i></span
            >
          </div>
        </div>
      </div>

      <!-- First Part Header of Quadrants -->
      <div class="columns">
        <div class="column is-3">
          <div class="box">
            <div class="level-item has-text-centered">
              <div>
                <p class="heading has-text-weight-bold">Género</p>
                <y-graph
                  :datagraph="
                    createDataGraphDona(
                      filteredData['dataAdmin']['Sexo'] ||
                        filteredData['dataAdmin']['Género'],
                      frsm['responses']['AGR-Sexo'] ||
                        frsm['responses']['AGR-Género']
                    )
                  "
                  :cambio="cambio"
                ></y-graph>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="box">
            <div
              class="level-item has-text-centered"
              style="width: 100% !important; display: block !important; max-height: 171.5px !important;"
            >
              <div>
                <p class="heading has-text-weight-bold">Edad</p>
                <y-graph
                  :datagraph="
                    createDataGraphBar(
                      filteredData['dataAdmin']['Edad'],
                      frsm['responses']['AGR-Edad']
                    )
                  "
                  :cambio="cambio"
                ></y-graph>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-3">
          <div class="box">
            <div class="level-item has-text-centered">
              <div>
                <p class="heading has-text-weight-bold">Forma</p>
                <y-graph
                  :datagraph="
                    createDataGraphDona(
                      filteredData['dataAdmin']['FORMA'] ||
                        filteredData['dataAdmin']['Forma'],
                      frsm['responses']['AGR-FORMA'] ||
                        frsm['responses']['AGR-Forma']
                    )
                  "
                  :cambio="cambio"
                ></y-graph>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Options Historical -->
      <div
        class="is-flex"
        style="justify-content: space-between !important; margin-bottom: 10px !important;"
      >
        <div class="is-flex" v-if="!this.$route.params.id">
          <div class="control">
            <div class="select is-small">
              <!-- class is-loading for animate of loading -->
              <select
                :disabled="!board.historic.years"
                v-model="selects.inputHistoric"
              >
                <option value="" disabled selected>{{
                  board.historic.years
                    ? "Selecciona un histórico"
                    : "No hay histórico"
                }}</option>
                <option
                  v-for="(v, k) in board.historic.years"
                  :key="k"
                  :value="v"
                  >Histórico - {{ v }}</option
                >
              </select>
            </div>
          </div>

          <menu-filters-historic
            v-if="board.historic.selectYear"
            ref="menuGroupsHistoric"
            :data="getGroupsHistoric()"
            @setFilterHistoric="setFilterHistoric"
            @deleteFilterHistoric="deleteFilterHistoric"
          />

          <span
            v-tooltip="'Eliminar selección'"
            v-if="board.historic.selectYear"
            v-on:click="deleteSelectionHistoric"
            class="icon is-left is-danger"
            style="color: #f38282; margin-left: 10px; cursor: pointer;"
          >
            <i class="material-icons">delete_forever</i>
          </span>
        </div>
        <div v-if="this.$route.params.id">
          <div class="control" v-if="board.historic.selectYear !== ''">
            <div class="tags has-addons">
              <span class="tag is-grey-light">Histórico</span>
              <span class="tag is-blue">{{ board.historic.selectYear }}</span>
            </div>
          </div>
        </div>
        <div v-if="!this.$route.params.id">
          <div
            class="tags has-addons"
            style="cursor: pointer"
            v-on:click="downloadReport()"
          >
            <span
              class="tag is-grey-light"
              v-tooltip="'Clic para descargar PDF de todo el informe.'"
              >Descargar Informe General</span
            >
            <span class="tag is-dark"
              ><i class="material-icons is-size-5">download</i></span
            >
          </div>
        </div>
        <div style="display: flex; gap: 8px;">
          <div
            v-if="!this.$route.params.id"
            v-tooltip="
              this.board.benchmark
                ? 'Clic para cerrar benchmark'
                : 'Clic para ver benchmark'
            "
            v-on:click="showCtx"
          >
            <a class="button is-small">{{
              board.benchmark ? "Cerrar benchmark" : "Benchmark"
            }}</a>
          </div>
          <div
            v-if="!this.$route.params.id"
            v-tooltip="
              this.board.demo
                ? 'Clic para cerrar los demográficos'
                : 'Clic para ver los demográficos'
            "
            v-on:click="showDemo"
          >
            <a class="button is-small">{{
              board.demo ? "Cerrar demográficos" : "Demográficos"
            }}</a>
          </div>
        </div>
      </div>

      <!-- Demographic -->
      <transition name="fade">
        <Demographic
          v-if="board.demo"
          :frsm="frsm"
          @sortData="sortData"
        ></Demographic>
      </transition>

      <!-- Benchmark -->
      <transition name="fade">
        <Benchmark
          v-if="board.benchmark"
          :frsm="frsm"
          :groups="groups"
          :efectos="efectos"
          :rangoIntervencion="rangoIntervencion"
          :showSubGroups="showSubGroups"
          :createBodyTooltipInter="createBodyTooltipInter"
          :getDataInter="getDataInter"
          :validateDataGraph="validateDataGraph"
          :calculatePorcentage="calculatePorcentage"
          :rangoFp="rangoFp"
        ></Benchmark>
      </transition>

      <div v-if="!board.demo && !board.benchmark">
        <!-- Second Part Header of Quadrants -->

        <div class="box">
          <div class="columns has-text-centered">
            <div class="column is-one-third">
              <span class="heading has-text-weight-bold"
                >Prioridad de intervención</span
              >
              <div class="column">
                <table class="is-flex is-fullwidth" id="table-1">
                  <tr
                    class="bg-alta"
                    v-tooltip.bottom="{
                      content: `<span class='has-text-centered' style='width: 100%'>Si Riesgo Alto y Riesgo muy alto es mayor o igual a 30%</span>`,
                      classes: 'contentTooltipRangeInter',
                    }"
                  >
                    Alta
                  </tr>
                  <tr
                    class="bg-media"
                    v-tooltip.bottom="{
                      content: `<span class='has-text-centered' style='width: 100%'>Si Riesgo Alto y Riesgo muy alto es menor a 30%, pero Riesgo alto, muy alto y medio es mayor o igual a 40%</span>`,
                      classes: 'contentTooltipRangeInter',
                    }"
                  >
                    Media
                  </tr>
                  <tr
                    class="bg-destacado"
                    v-tooltip.bottom="{
                      content: `<span class='has-text-centered' style='width: 100%'>Si sin riesgo o riesgo bajo es mayor o igual a 60%</span>`,
                      classes: 'contentTooltipRangeInter',
                    }"
                  >
                    Destacado
                  </tr>
                </table>
              </div>
            </div>
            <div class="column">
              <span class="heading has-text-weight-bold"
                >Niveles de riesgo</span
              >
              <div class="column">
                <table class="is-flex is-fullwidth" id="table-2">
                  <tr
                    class="bg-muyAlto"
                    v-tooltip.bottom="{
                      content: `<span class='has-text-centered' style='width: 100%'><strong class='has-text-white'>Muy alto</strong><br><br>Nivel de riesgo con amplia posibilidad de asociarse a respuestas muy altas de estrés. Por consiguiente, las dimensiones y dominios que se encuentren bajo esta categoría requieren intervención inmediata en el marco de un sistema de vigilancia epidemiológica.</span>`,
                      classes: 'contentTooltipRangeInter',
                    }"
                  >
                    Muy alto
                  </tr>
                  <tr
                    class="bg-alto"
                    v-tooltip.bottom="{
                      content: `<span class='has-text-centered' style='width: 100%'><strong class='has-text-white'>Alto</strong><br><br>Nivel de riesgo que tiene una importante posibilidad de asociación con respuestas de estrés alto y por tanto, las dimensiones y dominios que se encuentren bajo esta categoría requieren intervención en el marco de un sistema de vigilancia epidemiológica.</span>`,
                      classes: 'contentTooltipRangeInter',
                    }"
                  >
                    Alto
                  </tr>
                  <tr
                    class="bg-media"
                    v-tooltip.bottom="{
                      content: `<span class='has-text-centered' style='width: 100%'><strong class='has-text-white'>Medio</strong><br><br>Nivel de riesgo en el que se esperaría una respuesta de estrés moderada. Las dimensiones y dominios que se encuentren bajo esta categoría ameritan observación y acciones sistemáticas de intervención para prevenir efectos perjudiciales en la salud.</span>`,
                      classes: 'contentTooltipRangeInter',
                    }"
                  >
                    Medio
                  </tr>
                  <tr
                    class="bg-bajo"
                    v-tooltip.bottom="{
                      content: `<span class='has-text-centered' style='width: 100%'><strong class='has-text-white'>Bajo</strong><br><br>No se espera que los factores psicosociales que obtengan puntuaciones en este nivel estén relacionados con síntomas o respuestas de estrés significativas. Las dimensiones y dominios que se encuentren bajo esta categoría serán objeto de acciones o programas de intervención, a fin de mantenerlos en los niveles de riesgo más bajos posibles.<br><strong>Este rango no aplica para las condiciones individuales.</strong></span>`,
                      classes: 'contentTooltipRangeInter',
                    }"
                  >
                    Bajo
                  </tr>
                  <tr
                    class="bg-noRiesgo"
                    v-tooltip.bottom="{
                      content: `<span class='has-text-centered' style='width: 100%'><strong class='has-text-white'>Sin riesgo o riesgo despreciable</strong><br><br>Ausencia de riesgo o riesgo tan bajo que no amerita desarrollar actividades de intervención. Las dimensiones y dominios que se encuentren bajo esta categoría serán objeto de acciones o programas de promoción.</span>`,
                      classes: 'contentTooltipRangeInter',
                    }"
                  >
                    Sin riesgo...
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Third Part Quadrants -->

        <div class="box">
          <!-- Principales -->
          <div v-for="(v, k) in groups" :key="k + 'graphsP'">
            <!-- Data Normal -->
            <div class="columns has-text-centered">
              <!-- Column Title -->
              <div class="column is-one-third">
                <div>
                  <div
                    class="heading is-size-6 border"
                    :class="
                      rangoIntervencion(filteredData['dataAdmin'][v.first])
                    "
                    style="padding-top: 5px; margin-top: 15px;"
                  >
                    <div class="columns">
                      <!-- Icon -->
                      <div class="column is-2">
                        <i
                          class="material-icons has-text-white icon-dash"
                          v-tooltip.top="'Ver más'"
                          v-on:click="showSubGroups(k)"
                          style="cursor: pointer;"
                        >
                          {{
                            v.active
                              ? "remove_circle_outline"
                              : "add_circle_outline"
                          }}
                        </i>
                      </div>
                      <!-- Text -->
                      <div class="column titleC">
                        {{
                          interpretations[v.first]
                            ? interpretations[v.first].title
                            : "Error en los datos."
                        }}
                      </div>
                      <div
                        v-tooltip.top="{
                          content: createBodyTooltipInter(v),
                          classes: 'contentTooltipInter',
                        }"
                        class="column is-2"
                        v-on:click="
                          getDataInter(
                            filteredData['dataAdmin'][v.first],
                            v.title
                          )
                        "
                      >
                        <i
                          class="material-icons has-text-white icon-dash"
                          style="cursor: pointer;"
                        >
                          info
                        </i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Columns Graph -->
              <div class="column">
                <div
                  style="padding-top: 0.6% !important; margin: 0px !important; width: 100%"
                >
                  <div
                    class="has-text-centered content-nodata-graph"
                    :class="
                      rangoIntervencion(filteredData['dataAdmin'][v.first])
                    "
                    v-if="
                      !validateDataGraph(filteredData['dataAdmin'][v.first])
                    "
                  >
                    <span class="is-flex"
                      ><i class="material-icons">insert_chart</i>&nbsp;No hay
                      suficientes datos</span
                    >
                  </div>

                  <y-graph
                    v-if="validateDataGraph(filteredData['dataAdmin'][v.first])"
                    :datagraph="
                      createDataGraphHorizontalBar(
                        filteredData['dataAdmin'][v.first],
                        v.title
                      )
                    "
                    :cambio="cambio"
                    style="height: 65px !important;"
                  ></y-graph>
                </div>
              </div>
            </div>
            <!-- Data Historic -->
            <div
              class="columns has-text-centered content-historic"
              v-if="
                board.historic.selectYear !== '' &&
                  filteredDataHistoric[v.first]
              "
            >
              <!-- Column Title -->
              <div class="column is-one-third">
                <div>
                  <div
                    class="heading is-size-6 border"
                    :class="rangoIntervencion(filteredDataHistoric[v.first])"
                    style="padding-top: 5px; margin-top: 15px;"
                  >
                    <div class="columns">
                      <div class="column is-2"></div>
                      <!-- Text -->
                      <div class="column titleC">
                        {{
                          interpretations[v.first]
                            ? board.historic.selectYear +
                              " - " +
                              interpretations[v.first].title
                            : "Error en los datos."
                        }}
                      </div>
                      <div
                        v-tooltip.top="{
                          content: createBodyTooltipInter(v),
                          classes: 'contentTooltipInter',
                        }"
                        class="column is-2"
                        v-on:click="
                          getDataInter(filteredDataHistoric[v.first], v.title)
                        "
                      >
                        <i
                          class="material-icons has-text-white icon-dash"
                          style="cursor: pointer;"
                        >
                          info
                        </i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Columns Graph -->
              <div class="column">
                <div
                  style="padding-top: 0.6% !important; margin: 0px !important; width: 100%"
                >
                  <div
                    class="has-text-centered content-nodata-graph"
                    :class="rangoIntervencion(filteredDataHistoric[v.first])"
                    v-if="!validateDataGraph(filteredDataHistoric[v.first])"
                  >
                    <span class="is-flex"
                      ><i class="material-icons">insert_chart</i>&nbsp;No hay
                      suficientes datos</span
                    >
                  </div>

                  <y-graph
                    v-if="validateDataGraph(filteredDataHistoric[v.first])"
                    :datagraph="
                      createDataGraphHorizontalBar(
                        filteredDataHistoric[v.first],
                        v.title
                      )
                    "
                    :cambio="cambio"
                    style="height: 65px !important;"
                  ></y-graph>
                </div>
              </div>
            </div>

            <article v-if="v.sub && !v.sub2 && v.active" class="message">
              <div class="message-body">
                <div v-for="(vS, kS) in v.sub" :key="kS + 'sub1'">
                  <!-- Data Normal -->
                  <div class="columns has-text-centered">
                    <!-- Column Title -->
                    <div class="column is-one-third">
                      <div>
                        <div
                          class="heading is-size-6 border"
                          :class="
                            rangoIntervencion(
                              filteredData['dataAdmin'][vS.first]
                            )
                          "
                          style="padding-top: 5px; margin-top: 15px;"
                        >
                          <div class="columns">
                            <div class="column is-2"></div>
                            <!-- Text -->
                            <div class="column titleC">
                              {{
                                interpretations[vS.first]
                                  ? interpretations[vS.first].title
                                  : "Error en los datos."
                              }}
                            </div>
                            <div
                              v-tooltip.top="{
                                content: createBodyTooltipInter(vS),
                                classes: 'contentTooltipInter',
                              }"
                              class="column is-2"
                              v-on:click="
                                getDataInter(
                                  filteredData['dataAdmin'][vS.first],
                                  vS.title
                                )
                              "
                            >
                              <i
                                class="material-icons has-text-white icon-dash"
                                style="cursor: pointer;"
                              >
                                info
                              </i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Columns Graph -->
                    <div class="column">
                      <div
                        style="padding-top: 0.6% !important; margin: 0px !important;"
                      >
                        <div
                          class="has-text-centered content-nodata-graph"
                          :class="
                            rangoIntervencion(
                              filteredData['dataAdmin'][vS.first]
                            )
                          "
                          v-if="
                            !validateDataGraph(
                              filteredData['dataAdmin'][vS.first]
                            )
                          "
                        >
                          <span class="is-flex"
                            ><i class="material-icons">insert_chart</i>&nbsp;No
                            hay suficientes datos</span
                          >
                        </div>

                        <y-graph
                          v-if="
                            validateDataGraph(
                              filteredData['dataAdmin'][vS.first]
                            )
                          "
                          :datagraph="
                            createDataGraphHorizontalBar(
                              filteredData['dataAdmin'][vS.first],
                              vS.title
                            )
                          "
                          :cambio="cambio"
                          style="height: 65px !important;"
                        ></y-graph>
                      </div>
                    </div>
                  </div>
                  <!-- Data Historic -->
                  <div
                    class="columns has-text-centered content-historic"
                    v-if="
                      board.historic.selectYear !== '' &&
                        filteredDataHistoric[vS.first]
                    "
                  >
                    <!-- Column Title -->
                    <div class="column is-one-third">
                      <div>
                        <div
                          class="heading is-size-6 border"
                          :class="
                            rangoIntervencion(filteredDataHistoric[vS.first])
                          "
                          style="padding-top: 5px; margin-top: 15px;"
                        >
                          <div class="columns">
                            <div class="column is-2"></div>
                            <!-- Text -->
                            <div class="column titleC">
                              {{
                                interpretations[vS.first]
                                  ? interpretations[vS.first].title
                                  : "Error en los datos."
                              }}
                            </div>
                            <div
                              v-tooltip.top="{
                                content: createBodyTooltipInter(vS),
                                classes: 'contentTooltipInter',
                              }"
                              class="column is-2"
                              v-on:click="
                                getDataInter(
                                  filteredDataHistoric[vS.first],
                                  vS.title
                                )
                              "
                            >
                              <i
                                class="material-icons has-text-white icon-dash"
                                style="cursor: pointer;"
                              >
                                info
                              </i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Columns Graph -->
                    <div class="column">
                      <div
                        style="padding-top: 0.6% !important; margin: 0px !important;"
                      >
                        <div
                          class="has-text-centered content-nodata-graph"
                          :class="
                            rangoIntervencion(filteredDataHistoric[vS.first])
                          "
                          v-if="
                            !validateDataGraph(filteredDataHistoric[vS.first])
                          "
                        >
                          <span class="is-flex"
                            ><i class="material-icons">insert_chart</i>&nbsp;No
                            hay suficientes datos</span
                          >
                        </div>

                        <y-graph
                          v-if="
                            validateDataGraph(filteredDataHistoric[vS.first])
                          "
                          :datagraph="
                            createDataGraphHorizontalBar(
                              filteredDataHistoric[vS.first],
                              vS.title
                            )
                          "
                          :cambio="cambio"
                          style="height: 65px !important;"
                        ></y-graph>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>

            <article v-if="v.sub2 && v.active" class="message">
              <div class="message-body">
                <div v-for="(vS, kS) in v.sub2" :key="kS + 'sub2'">
                  <!-- Data Normal -->
                  <div class="columns has-text-centered">
                    <!-- Column Title -->
                    <div class="column is-one-third">
                      <div>
                        <div
                          class="heading is-size-6 border"
                          :class="
                            rangoIntervencion(
                              filteredData['dataAdmin'][vS.first]
                            )
                          "
                          style="padding-top: 5px; margin-top: 15px;"
                        >
                          <div class="columns">
                            <!-- Icon -->
                            <div class="column is-2">
                              <i
                                data-tooltip="Ver más"
                                class="material-icons has-text-white icon-dash"
                                v-on:click="showSubGroups(k, kS)"
                                style="cursor: pointer;"
                              >
                                {{
                                  vS.active
                                    ? "remove_circle_outline"
                                    : "add_circle_outline"
                                }}
                              </i>
                            </div>
                            <!-- Text -->
                            <div class="column titleC">
                              {{
                                interpretations[vS.first]
                                  ? interpretations[vS.first].title
                                  : "Error en los datos."
                              }}
                            </div>
                            <div
                              v-tooltip.top="{
                                content: createBodyTooltipInter(vS),
                                classes: 'contentTooltipInter',
                              }"
                              class="column is-2"
                              v-on:click="
                                getDataInter(
                                  filteredData['dataAdmin'][vS.first],
                                  vS.title
                                )
                              "
                            >
                              <i
                                class="material-icons has-text-white icon-dash"
                                style="cursor: pointer;"
                              >
                                info
                              </i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Columns Graph -->
                    <div class="column">
                      <div
                        style="padding-top: 0.6% !important; margin: 0px !important;"
                      >
                        <div
                          class="has-text-centered content-nodata-graph"
                          :class="
                            rangoIntervencion(
                              filteredData['dataAdmin'][vS.first]
                            )
                          "
                          v-if="
                            !validateDataGraph(
                              filteredData['dataAdmin'][vS.first]
                            )
                          "
                        >
                          <span class="is-flex"
                            ><i class="material-icons">insert_chart</i>&nbsp;No
                            hay suficientes datos</span
                          >
                        </div>
                        <y-graph
                          v-if="
                            validateDataGraph(
                              filteredData['dataAdmin'][vS.first]
                            )
                          "
                          :datagraph="
                            createDataGraphHorizontalBar(
                              filteredData['dataAdmin'][vS.first],
                              vS.title
                            )
                          "
                          :cambio="cambio"
                          style="height: 65px !important;"
                        ></y-graph>
                      </div>
                    </div>
                  </div>
                  <!-- Data Historic -->
                  <div
                    class="columns has-text-centered content-historic"
                    v-if="
                      board.historic.selectYear !== '' &&
                        filteredDataHistoric[vS.first]
                    "
                  >
                    <!-- Column Title -->
                    <div class="column is-one-third">
                      <div>
                        <div
                          class="heading is-size-6 border"
                          :class="
                            rangoIntervencion(filteredDataHistoric[vS.first])
                          "
                          style="padding-top: 5px; margin-top: 15px;"
                        >
                          <div class="columns">
                            <div class="column is-2"></div>
                            <!-- Text -->
                            <div class="column titleC">
                              {{
                                interpretations[vS.first]
                                  ? interpretations[vS.first].title
                                  : "Error en los datos."
                              }}
                            </div>
                            <div
                              v-tooltip.top="{
                                content: createBodyTooltipInter(vS),
                                classes: 'contentTooltipInter',
                              }"
                              class="column is-2"
                              v-on:click="
                                getDataInter(
                                  filteredDataHistoric[vS.first],
                                  vS.title
                                )
                              "
                            >
                              <i
                                class="material-icons has-text-white icon-dash"
                                style="cursor: pointer;"
                              >
                                info
                              </i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Columns Graph -->
                    <div class="column">
                      <div
                        style="padding-top: 0.6% !important; margin: 0px !important;"
                      >
                        <div
                          class="has-text-centered content-nodata-graph"
                          :class="
                            rangoIntervencion(filteredDataHistoric[vS.first])
                          "
                          v-if="
                            !validateDataGraph(filteredDataHistoric[vS.first])
                          "
                        >
                          <span class="is-flex"
                            ><i class="material-icons">insert_chart</i>&nbsp;No
                            hay suficientes datos</span
                          >
                        </div>

                        <y-graph
                          v-if="
                            validateDataGraph(filteredDataHistoric[vS.first])
                          "
                          :datagraph="
                            createDataGraphHorizontalBar(
                              filteredDataHistoric[vS.first],
                              vS.title
                            )
                          "
                          :cambio="cambio"
                          style="height: 65px !important;"
                        ></y-graph>
                      </div>
                    </div>
                  </div>

                  <article
                    v-if="!v.sub && v.sub2 && vS.sub && vS.active"
                    class="message"
                  >
                    <div class="message-body">
                      <div v-for="(vT, kT) in vS.sub" :key="kT + 'sub3'">
                        <!-- Data Normal -->
                        <div class="columns has-text-centered">
                          <!-- Column Title -->
                          <div class="column is-one-third">
                            <div>
                              <div
                                class="heading is-size-6 border"
                                :class="
                                  rangoIntervencion(
                                    filteredData['dataAdmin'][vT.first]
                                  )
                                "
                                style="padding-top: 5px; margin-top: 15px;"
                              >
                                <div class="columns">
                                  <div class="column is-2"></div>
                                  <!-- Text -->
                                  <div class="column titleC">
                                    {{ interpretations[vT.first].title }}
                                  </div>
                                  <div
                                    v-tooltip.top="{
                                      content: createBodyTooltipInter(vT),
                                      classes: 'contentTooltipInter',
                                    }"
                                    class="column is-2"
                                  >
                                    <i
                                      class="material-icons has-text-white icon-dash"
                                      style="cursor: pointer;"
                                      v-on:click="
                                        getDataInter(
                                          filteredData['dataAdmin'][vT.first],
                                          vT.title
                                        )
                                      "
                                    >
                                      info
                                    </i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- Columns Graph -->
                          <div class="column">
                            <div
                              style="padding-top: 0.6% !important; margin: 0px !important;"
                            >
                              <div
                                class="has-text-centered content-nodata-graph"
                                :class="
                                  rangoIntervencion(
                                    filteredData['dataAdmin'][vT.first]
                                  )
                                "
                                v-if="
                                  !validateDataGraph(
                                    filteredData['dataAdmin'][vT.first]
                                  )
                                "
                              >
                                <span class="is-flex"
                                  ><i class="material-icons">insert_chart</i
                                  >&nbsp;No hay suficientes datos</span
                                >
                              </div>
                              <y-graph
                                v-if="
                                  validateDataGraph(
                                    filteredData['dataAdmin'][vT.first]
                                  )
                                "
                                :datagraph="
                                  createDataGraphHorizontalBar(
                                    filteredData['dataAdmin'][vT.first],
                                    vT.title
                                  )
                                "
                                :cambio="cambio"
                                style="height: 65px !important;"
                              ></y-graph>
                            </div>
                          </div>
                        </div>
                        <!-- Data Historic -->
                        <div
                          class="columns has-text-centered content-historic"
                          v-if="
                            board.historic.selectYear !== '' &&
                              filteredDataHistoric[vT.first]
                          "
                        >
                          <!-- Column Title -->
                          <div class="column is-one-third">
                            <div>
                              <div
                                class="heading is-size-6 border"
                                :class="
                                  rangoIntervencion(
                                    filteredDataHistoric[vT.first]
                                  )
                                "
                                style="padding-top: 5px; margin-top: 15px;"
                              >
                                <div class="columns">
                                  <div class="column is-2"></div>
                                  <!-- Text -->
                                  <div class="column titleC">
                                    {{ interpretations[vT.first].title }}
                                  </div>
                                  <div
                                    v-tooltip.top="{
                                      content: createBodyTooltipInter(vT),
                                      classes: 'contentTooltipInter',
                                    }"
                                    class="column is-2"
                                  >
                                    <i
                                      class="material-icons has-text-white icon-dash"
                                      style="cursor: pointer;"
                                      v-on:click="
                                        getDataInter(
                                          filteredDataHistoric[vT.first],
                                          vT.title
                                        )
                                      "
                                    >
                                      info
                                    </i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- Columns Graph -->
                          <div class="column">
                            <div
                              style="padding-top: 0.6% !important; margin: 0px !important;"
                            >
                              <div
                                class="has-text-centered content-nodata-graph"
                                :class="
                                  rangoIntervencion(
                                    filteredDataHistoric[vT.first]
                                  )
                                "
                                v-if="
                                  !validateDataGraph(
                                    filteredDataHistoric[vT.first]
                                  )
                                "
                              >
                                <span class="is-flex"
                                  ><i class="material-icons">insert_chart</i
                                  >&nbsp;No hay suficientes datos</span
                                >
                              </div>

                              <y-graph
                                v-if="
                                  validateDataGraph(
                                    filteredDataHistoric[vT.first]
                                  )
                                "
                                :datagraph="
                                  createDataGraphHorizontalBar(
                                    filteredDataHistoric[vT.first],
                                    vS.title
                                  )
                                "
                                :cambio="cambio"
                                style="height: 65px !important;"
                              ></y-graph>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </article>
          </div>
        </div>

        <div class="is-flex is-justify-center">
          <!-- Title Efectos -->
          <hr class="has-text-dark" style="width: 30%" />
          <h1
            class="title is-size-4 is-flex"
            style="margin-top: 10px; margin-right: 15px; margin-left: 15px"
          >
            Efectos
            <div
              v-tooltip.top="{
                content: createBodyTooltipInter({ first: 'EFECTOS' }),
                classes: 'contentTooltipInter',
              }"
              style="padding-left: 10px;padding-top: 2px;"
            >
              <i class="material-icons has-text-black-bis">
                info_outline
              </i>
            </div>
          </h1>
          <hr class="has-text-dark" style="width: 30%" />
        </div>

        <div class="box">
          <!-- Efectos -->
          <div v-for="(v, k) in efectos" :key="k + 'graphsE'">
            <div v-if="v.first === 'RGO-09-Engagement'">
              <!-- Part Header of Quadrants - Engagement -->
              <div style="margin-right: 10px; margin-left: 10px;">
                <hr />
              </div>
              <div class="columns has-text-centered">
                <div class="column is-one-third">
                  <span class="heading has-text-weight-bold"
                    >Prioridad de intervención</span
                  >
                  <div class="column">
                    <table class="is-flex is-fullwidth" id="table-1">
                      <tr
                        class="bg-alta"
                        v-tooltip.bottom="{
                          content: `<span class='has-text-centered' style='width: 100%'>Si Muy bajo y bajo es mayor o igual a 30%</span>`,
                          classes: 'contentTooltipRangeInter',
                        }"
                      >
                        Alta
                      </tr>
                      <tr
                        class="bg-media"
                        v-tooltip.bottom="{
                          content: `<span class='has-text-centered' style='width: 100%'>Si Muy bajo y bajo es menor a 30%, pero Muy bajo, bajo y medio es mayor o igual a 40%</span>`,
                          classes: 'contentTooltipRangeInter',
                        }"
                      >
                        Media
                      </tr>
                      <tr
                        class="bg-destacado"
                        v-tooltip.bottom="{
                          content: `<span class='has-text-centered' style='width: 100%'>Si Muy alto y alto a 60%</span>`,
                          classes: 'contentTooltipRangeInter',
                        }"
                      >
                        Destacado
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="column">
                  <span class="heading has-text-weight-bold"
                    >Niveles de efecto</span
                  >
                  <div class="column">
                    <table class="is-flex is-fullwidth" id="table-2">
                      <tr class="bg-muyAltoEng">
                        Muy alto
                      </tr>
                      <tr class="bg-altoEng">
                        Alto
                      </tr>
                      <tr class="bg-media">
                        Medio
                      </tr>
                      <tr class="bg-bajoEng">
                        Bajo
                      </tr>
                      <tr class="bg-noRiesgoEng">
                        Muy bajo
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- Data Normal -->
            <div class="columns has-text-centered">
              <!-- Column Title -->
              <div class="column is-one-third">
                <div>
                  <div
                    class="heading is-size-6 border"
                    :class="
                      rangoIntervencion(
                        filteredData['dataAdmin'][v.first],
                        v.first === 'RGO-09-Engagement' ? 1 : 0
                      )
                    "
                    style="padding-top: 5px; margin-top: 15px;"
                  >
                    <div class="columns">
                      <!-- Icon -->
                      <div class="column is-2">
                        <i
                          class="material-icons has-text-white icon-dash"
                          v-tooltip.top="'Ver más'"
                          v-on:click="showSubGroups(k)"
                          v-if="v.sub && v.sub.length"
                          style="cursor: pointer;"
                        >
                          {{
                            v.active
                              ? "remove_circle_outline"
                              : "add_circle_outline"
                          }}
                        </i>
                      </div>
                      <!-- Text -->
                      <div class="column titleC">
                        {{ interpretations[v.first].title }}
                      </div>
                      <div
                        v-tooltip.top="{
                          content: createBodyTooltipInter(v),
                          classes: 'contentTooltipInter',
                        }"
                        class="column is-2"
                        v-on:click="
                          getDataInter(
                            filteredData['dataAdmin'][v.first],
                            v.title
                          )
                        "
                      >
                        <i
                          class="material-icons has-text-white icon-dash"
                          style="cursor: pointer;"
                        >
                          info
                        </i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Columns Graph -->
              <div class="column">
                <div
                  style="padding-top: 0.6% !important; margin: 0px !important; width: 100%"
                >
                  <div
                    class="has-text-centered content-nodata-graph"
                    :class="
                      rangoIntervencion(
                        filteredData['dataAdmin'][v.first],
                        v.first === 'RGO-09-Engagement' ? 1 : 0
                      )
                    "
                    v-if="
                      !validateDataGraph(filteredData['dataAdmin'][v.first])
                    "
                  >
                    <span class="is-flex"
                      ><i class="material-icons">insert_chart</i>&nbsp;No hay
                      suficientes datos</span
                    >
                  </div>
                  <y-graph
                    v-if="validateDataGraph(filteredData['dataAdmin'][v.first])"
                    :datagraph="
                      createDataGraphHorizontalBar(
                        filteredData['dataAdmin'][v.first],
                        v.title
                      )
                    "
                    :cambio="cambio"
                    style="height: 65px !important;"
                  ></y-graph>
                </div>
              </div>
            </div>
            <!-- Data Historic -->
            <div
              class="columns has-text-centered content-historic"
              v-if="
                board.historic.selectYear !== '' &&
                  filteredDataHistoric[v.first]
              "
            >
              <!-- Column Title -->
              <div class="column is-one-third">
                <div>
                  <div
                    class="heading is-size-6 border"
                    :class="
                      rangoIntervencion(
                        filteredDataHistoric[v.first],
                        v.first === 'RGO-09-Engagement' ? 1 : 0
                      )
                    "
                    style="padding-top: 5px; margin-top: 15px;"
                  >
                    <div class="columns">
                      <!-- Icon -->
                      <div class="column is-2">
                        <i
                          class="material-icons has-text-white icon-dash"
                          v-tooltip.top="'Ver más'"
                          v-on:click="showSubGroups(k)"
                          v-if="v.sub && v.sub.length"
                          style="cursor: pointer;"
                        >
                          {{
                            v.active
                              ? "remove_circle_outline"
                              : "add_circle_outline"
                          }}
                        </i>
                      </div>
                      <!-- Text -->
                      <div class="column titleC">
                        {{ board.historic.selectYear }} -
                        {{ interpretations[v.first].title }}
                      </div>
                      <div
                        v-tooltip.top="{
                          content: createBodyTooltipInter(v),
                          classes: 'contentTooltipInter',
                        }"
                        class="column is-2"
                        v-on:click="
                          getDataInter(filteredDataHistoric[v.first], v.title)
                        "
                      >
                        <i
                          class="material-icons has-text-white icon-dash"
                          style="cursor: pointer;"
                        >
                          info
                        </i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Columns Graph -->
              <div class="column">
                <div
                  style="padding-top: 0.6% !important; margin: 0px !important; width: 100%"
                >
                  <div
                    class="has-text-centered content-nodata-graph"
                    :class="
                      rangoIntervencion(
                        filteredDataHistoric[v.first],
                        v.first === 'RGO-09-Engagement' ? 1 : 0
                      )
                    "
                    v-if="!validateDataGraph(filteredDataHistoric[v.first])"
                  >
                    <span class="is-flex"
                      ><i class="material-icons">insert_chart</i>&nbsp;No hay
                      suficientes datos</span
                    >
                  </div>
                  <y-graph
                    v-if="validateDataGraph(filteredDataHistoric[v.first])"
                    :datagraph="
                      createDataGraphHorizontalBar(
                        filteredDataHistoric[v.first],
                        v.title
                      )
                    "
                    :cambio="cambio"
                    style="height: 65px !important;"
                  ></y-graph>
                </div>
              </div>
            </div>

            <article v-if="v.sub && v.sub.length && v.active" class="message">
              <div class="message-body">
                <div v-for="(vS, kS) in v.sub" :key="kS + 'sub4'">
                  <!-- Data Normal -->
                  <div class="columns has-text-centered">
                    <!-- Column Title -->
                    <div class="column is-one-third">
                      <div>
                        <div
                          class="heading is-size-6 border"
                          :class="
                            rangoIntervencion(
                              filteredData['dataAdmin'][vS.first]
                            )
                          "
                          style="padding-top: 5px; margin-top: 15px;"
                        >
                          <div class="columns">
                            <div class="is-2"></div>
                            <!-- Text -->
                            <div class="column titleC">
                              {{ interpretations[vS.first].title }}
                            </div>
                            <div
                              v-tooltip.top="{
                                content: createBodyTooltipInter(vS),
                                classes: 'contentTooltipInter',
                              }"
                              class="column is-2"
                              v-on:click="
                                getDataInter(
                                  filteredData['dataAdmin'][vS.first],
                                  vS.title
                                )
                              "
                            >
                              <i
                                class="material-icons has-text-white icon-dash"
                                style="cursor: pointer;"
                              >
                                info
                              </i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Columns Graph -->
                    <div class="column">
                      <div
                        style="padding-top: 0.6% !important; margin: 0px !important;"
                      >
                        <y-graph
                          :datagraph="
                            createDataGraphHorizontalBar(
                              filteredData['dataAdmin'][vS.first],
                              vS.title
                            )
                          "
                          :cambio="cambio"
                          style="height: 65px !important;"
                        ></y-graph>
                      </div>
                    </div>
                  </div>
                  <!-- Data Historic -->
                  <div
                    class="columns has-text-centered content-historic"
                    v-if="
                      board.historic.selectYear !== '' &&
                        filteredDataHistoric[vS.first]
                    "
                  >
                    <!-- Column Title -->
                    <div class="column is-one-third">
                      <div>
                        <div
                          class="heading is-size-6 border"
                          :class="
                            rangoIntervencion(filteredDataHistoric[vS.first])
                          "
                          style="padding-top: 5px; margin-top: 15px;"
                        >
                          <div class="columns">
                            <div class="is-2"></div>
                            <!-- Text -->
                            <div class="column titleC">
                              {{ board.historic.selectYear }} -
                              {{ interpretations[vS.first].title }}
                            </div>
                            <div
                              v-tooltip.top="{
                                content: createBodyTooltipInter(vS),
                                classes: 'contentTooltipInter',
                              }"
                              class="column is-2"
                              v-on:click="
                                getDataInter(
                                  filteredDataHistoric[vS.first],
                                  vS.title
                                )
                              "
                            >
                              <i
                                class="material-icons has-text-white icon-dash"
                                style="cursor: pointer;"
                              >
                                info
                              </i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Columns Graph -->
                    <div class="column">
                      <div
                        style="padding-top: 0.6% !important; margin: 0px !important;"
                      >
                        <div
                          class="has-text-centered content-nodata-graph"
                          :class="
                            rangoIntervencion(
                              filteredDataHistoric[vS.first],
                              v.first === 'RGO-09-Engagement' ? 1 : 0
                            )
                          "
                          v-if="
                            !validateDataGraph(filteredDataHistoric[vS.first])
                          "
                        >
                          <span class="is-flex"
                            ><i class="material-icons">insert_chart</i>&nbsp;No
                            hay suficientes datos</span
                          >
                        </div>
                        <y-graph
                          v-if="
                            validateDataGraph(filteredDataHistoric[vS.first])
                          "
                          :datagraph="
                            createDataGraphHorizontalBar(
                              filteredDataHistoric[vS.first],
                              vS.title
                            )
                          "
                          :cambio="cambio"
                          style="height: 65px !important;"
                        ></y-graph>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>

        <div v-if="!this.$route.params.id" class="is-flex is-justify-center">
          <hr class="has-text-dark" style="width: 20%" />
          <h1
            class="title is-size-4"
            style="margin-top: 10px; margin-right: 15px; margin-left: 15px"
          >
            Prioridad de Intervención en subgrupos
          </h1>
          <hr class="has-text-dark" style="width: 20%" />
        </div>

        <table-r
          v-if="!this.$route.params.id"
          ref="tableFrsm"
          :datos="table.data"
          :limitSelection="table.limitSelection"
          :filters="board.filter"
          @calculatePorcentage="calculatePorcentage"
          @setFilterTable="setFilterTable"
        ></table-r>
        <div
          v-if="
            filteredData['dataAdmin']['COMENTARIO'] && !this.$route.params.id
          "
        >
          <div style="margin-bottom: 40px;" class="is-flex is-justify-center">
            <hr class="has-text-dark" style="width: 20%" />
            <h1
              class="title is-size-4"
              style="margin-top: 10px; margin-right: 15px; margin-left: 15px"
            >
              Comentarios
            </h1>
            <hr class="has-text-dark" style="width: 20%" />
          </div>

          <div style="height: 330px !important; overflow-y: scroll;">
            <div
              v-for="(v, k) in filteredData['dataAdmin']['COMENTARIO']"
              :key="k + 'comment'"
            >
              <div v-if="v['SubGrupo']">
                <article
                  class="media"
                  style="padding-bottom: 15px"
                  v-for="item in v['countData']['sum']"
                  :key="item"
                >
                  <figure class="media-left">
                    <p class="image">
                      <i class="material-icons is-size-1">account_box</i>
                    </p>
                  </figure>
                  <div class="media-content">
                    <div class="content">
                      <p>
                        <strong>Anónimo</strong>
                        <br />
                        {{ v.SubGrupo }}
                      </p>
                    </div>
                    <!-- <nav class="level is-mobile">
                      <div class="level-left">
                        <a class="level-item">
                          <span class="icon is-small"><i class="fas fa-reply"></i></span>
                        </a>
                        <a class="level-item">
                          <span class="icon is-small"><i class="fas fa-retweet"></i></span>
                        </a>
                        <a class="level-item">
                          <span class="icon is-small"><i class="fas fa-heart"></i></span>
                        </a>
                      </div>
                    </nav> -->
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>

      <menu-interpretacion
        v-if="board.inter.active"
        :data="board.inter.data"
        @closeMenuInter="closeMenuInter"
      ></menu-interpretacion>

      <div style="margin-top: 150px;">
        <CardProfessional :logo="true" />
      </div>

      <Pdf
        ref="pdfFrp"
        component="ReportFRP"
        :namePdf="'Reporte Frp - ' + frsm.nombre"
        :componentProps="{ frsm, header, data: { ...groups, ...efectos } }"
      />
    </section>
  </div>
</template>
<script>
import apiServices from "@/services/yungol-services";
import CardProfessional from "../reports/components/frp/CardProfessional.vue";
import json from "./interpretaciones.json";
import Pdf from "../reports/Pdf.vue";
import menuInterpretacion from "./components/menuInterpretacion.vue";
import menuFiltersHistoric from "./components/menuFiltersHistoric.vue";
import yGraph from "@/components/dashboard/GraphFrs.vue";
import Demographic from "./Demographic.vue";
import Benchmark from "./Benchmark.vue";
import tableR from "./table.vue";
import { mapState } from "vuex";

export default {
  name: "Resultados",
  data: function() {
    return {
      dona: {
        data: {
          labels: ["Sin datos"],
          datasets: [
            {
              data: [100],
              backgroundColor: ["#d4d5d3"],
              borderColor: ["#919191"],
              /* backgroundColor: [
              '#f4cdcd',
              '#facca5',
              '#fff2cc',
              '#d9ead3',
              '#a2c4c9',
              '#c8d9f7',
              '#a9d0ef',
              '#e8d2f5',
              '#e7c2e1',
              '#c2e7e7',
              '#fab9a5'
            ],
            borderColor: [
              '#f6adad',
              '#f6b884',
              '#f6db8a',
              '#c3eab5',
              '#88c1cb',
              '#a8c2ef',
              '#95c5ec',
              '#deb8f3',
              '#efb4e5',
              '#bbf5f5',
              '#f5a992'
            ], */
              borderWidth: 1,
            },
          ],
        },
        options: {
          legend: {
            display: true,
            position: "right",
          },
          responsive: true,
          resizeDelay: 0,
          plugins: {
            datalabels: {
              formatter: function(value, context) {
                return `${value}%`;
              },
              color: "white",
              font: {
                weight: "bold",
              },
            },
          },
        },
        type: "pie",
      },
      horizontalBar: {
        type: "horizontalBar",
        options: {
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
            },
          },
          hover: {
            animationDuration: 0,
          },
          tooltips: {
            enabled: false,
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  display: false,
                },
                scaleLabel: {
                  display: false,
                },
                gridLines: {
                  display: false,
                },
                stacked: true,
              },
            ],
            yAxes: [
              {
                gridLines: {
                  display: false,
                },
                ticks: {
                  display: false,
                  beginAtZero: true,
                  max: 100,
                },
                stacked: true,
              },
            ],
          },
          legend: {
            position: "top",
            display: false,
          },
          animate: {},
          pointLabelFontFamily: "Quadon Extra Bold",
          scaleFontFamily: "Quadon Extra Bold",
          responsive: true,
          resizeDelay: 0,
          plugins: {
            datalabels: {
              formatter: function(value, context) {
                return `${value}%`;
              },
              textAlign: "start",
            },
          },
        },
        data: {
          labels: ["Data 1"],
          datasets: [
            {
              label: "Sin datos",
              data: [0],
              backgroundColor: ["#d4d5d3"],
            },
            {
              label: "Sin datos",
              data: [0],
              backgroundColor: ["#d4d5d3"],
            },
            {
              label: "Sin datos",
              data: [0],
              backgroundColor: ["#d4d5d3"],
            },
            {
              label: "Sin datos",
              data: [0],
              backgroundColor: ["#d4d5d3"],
            },
            {
              label: "Sin datos",
              data: [0],
              backgroundColor: ["#d4d5d3"],
            },
          ],
        },
      },
      bar: {
        type: "bar",
        options: {
          legend: {
            position: "top",
            display: false,
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
          responsive: true,
          resizeDelay: 0,
        },
        data: {
          labels: [
            "Sin datos",
            "Sin datos",
            "Sin datos",
            "Sin datos",
            "Sin datos",
            "Sin datos",
          ],
          datasets: [
            {
              label: "Filtro sin datos",
              data: [0, 0, 0, 0, 0, 0],
              backgroundColor: [
                "#d4d5d3",
                "#d4d5d3",
                "#d4d5d3",
                "#d4d5d3",
                "#d4d5d3",
                "#d4d5d3",
                "#d4d5d3",
                "#d4d5d3",
                "#d4d5d3",
                "#d4d5d3",
                "#d4d5d3",
              ],
            },
          ],
        },
      },
      cambio: 1,
      config: {
        cuadrante: {
          name: "",
          drop: false,
          data: {},
          childrens: {},
        },
      },
      groups: {
        intraLaborales: {
          code: "RGO-02",
          title: "Intralaborales",
          first: "RGO-02-TOTAL FRP INTRALABORALES",
          active: false,
          sub2: {
            liderazgoRelacionesSociales: {
              code: "RGO-03",
              title: "Liderazgo y relaciones",
              first: "RGO-03-LIDERAZGO Y RELACIONES SOCIALES EN EL TRABAJO",
              active: false,
            },
            controlSobreElTrabajo: {
              code: "RGO-04",
              title: "Control sobre el trabajo",
              first: "RGO-04-CONTROL SOBRE EL TRABAJO",
              active: false,
            },
            demandasDelTrabajo: {
              code: "RGO-05",
              title: "Demandas del trabajo",
              first: "RGO-05-DEMANDAS DEL TRABAJO",
              active: false,
            },
            recompensas: {
              code: "RGO-06",
              title: "Recompensas",
              first: "RGO-06-RECOMPENSAS",
              active: false,
            },
          },
        },
        extraLaborales: {
          code: "RGO-07",
          title: "Extralaborales",
          first: "RGO-07-TOTAL FRP EXTRALABORALES",
          active: false,
        },
        indicadorCondicionesIndividuales: {
          code: "RGO-08",
          title: "Condiciones Individuales",
          first: "RGO-08-INDICADOR CONDICIONES INDIVIDUALES",
          active: false,
        },
      },
      efectos: {
        burnout: {
          title: "Burnout",
          code: "RGO-10",
          first: "RGO-10-Burnout",
          active: false,
        },
        estres: {
          title: "Estrés",
          code: "RGO-11",
          first: "RGO-11-Estrés",
          active: false,
        },
        engagement: {
          title: "Engagement",
          code: "RGO-09",
          first: "RGO-09-Engagement",
          active: false,
        },
      },
      header: {
        date: "",
        participation: "",
        surveyed: 0,
        notconset: 0,
      },
      table: {
        data: null,
        gridOptions: null,
        limitSelection: 1,
      },
      board: {
        dataAdmin: null,
        filter: null,
        inter: {
          active: false,
          data: null,
        },
        historic: {
          filter: null,
          dataAdmin: {},
          dataFilter: {},
          dataGroups: [],
          years: null,
          selectYear: "",
        },
        demo: false,
        benchmark: false,
      },
      selects: {
        inputHistoric: "",
      },
      filterIsSticky: false,
      interpretations: json,
    };
  },
  props: {
    frsm: Object,
  },
  computed: {
    ...mapState(["idtoken", "isOculto"]),
    filteredData: function() {
      if (this.board.filter) {
        return this.board;
      } else {
        return this.frsm;
      }
    },
    filteredDataHistoric: function() {
      const selectYear = this.board.historic.selectYear;
      const filterCheck = this.board.historic.filter || this.board.filter;
      const isYear = filterCheck
        ? filterCheck.filter((x) => x.gr === "AGR-year").length
        : false;
      if (selectYear.length && !!filterCheck && !isYear) {
        console.log("filter", this.board.historic.dataFilter);
        return this.board.historic.dataFilter;
      } else if (
        selectYear.length &&
        Object.keys(this.board.historic.dataAdmin).length
      ) {
        console.log("normal", !isYear);
        return this.board.historic.dataAdmin[selectYear];
      } else {
        console.log("nada");
        return {};
      }
    },
  },
  methods: {
    // Graphs
    createDataGraphDona(data, labels) {
      if (data && labels) {
        const dataDona = {
          data: {
            labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
            datasets: [
              {
                data: [12, 19, 3, 5, 2, 3],
                backgroundColor: [
                  "#f4cdcd",
                  "#facca5",
                  "#fff2cc",
                  "#d9ead3",
                  "#a2c4c9",
                  "#c8d9f7",
                  "#a9d0ef",
                  "#e8d2f5",
                  "#e7c2e1",
                  "#c2e7e7",
                  "#fab9a5",
                ],
                borderColor: [
                  "#f6adad",
                  "#f6b884",
                  "#f6db8a",
                  "#c3eab5",
                  "#88c1cb",
                  "#a8c2ef",
                  "#95c5ec",
                  "#deb8f3",
                  "#efb4e5",
                  "#bbf5f5",
                  "#f5a992",
                ],
                borderWidth: 1,
              },
            ],
          },
          options: {
            legend: {
              display: true,
              position: "right",
            },
            responsive: true,
            resizeDelay: 0,
            plugins: {
              datalabels: {
                formatter: function(value, context) {
                  if (value >= 3) return `${value}%`;
                  return "";
                },
                textAlign: "start",
                // color: 'grey',
                // font: {
                //  weight: 'bold'
                // }
              },
            },
          },
          type: "pie",
        };

        const sumData = data
          .map((x) => {
            if (x.SubGrupo) return x["countData"]["sum"];
            return 0;
          })
          .reduce((a, b) => a + b, 0);

        dataDona.data.labels = data
          .filter((x) => {
            if (x.SubGrupo) return true;
          })
          .map((x) => x.SubGrupo);

        dataDona.data.datasets[0].data = data
          .filter((x) => {
            if (x.SubGrupo) return true;
          })
          .map((x) => {
            return ((x["countData"]["sum"] * 100) / sumData).toFixed(1);
          });

        dataDona.data.datasets[0].backgroundColor = [
          "#a9d0ef",
          "#e7c7fa",
          "#e7c2e1",
        ];
        dataDona.data.datasets[0].borderColor = [
          "#95c5ec",
          "#deb8f3",
          "#efb4e5",
        ];

        return dataDona;
      }
      return this.dona;
    },
    createDataGraphBar(data, labels) {
      if (data && labels) {
        labels = labels.SubGrupo;
        labels = this.sortData(labels, false);
        data = labels.map((x) => {
          const value = data.filter((d) => d.SubGrupo === x);
          if (value.length) return value[0];
          return {
            Grupo: "Edad",
            SubGrupo: x,
            check: false,
            check2: false,
            countData: {
              sum: 0,
            },
          };
        });
        const dataBar = this.bar;

        dataBar.data.labels = labels.map((x) => x || "Sin subgrupo");
        dataBar.data.datasets[0].data = data.map((x) => x["countData"]["sum"]);

        dataBar.data.datasets[0].label = data[0].Grupo;
        dataBar.data.datasets[0].backgroundColor = "#a9d0ef";

        return dataBar;
      }
      return this.bar;
    },
    createDataGraphHorizontalBar: function(data, label) {
      if (data && label) {
        const dataHorizontalBar = {
          type: "horizontalBar",
          options: {
            layout: {
              padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
              },
            },
            hover: {
              animationDuration: 0,
            },
            tooltips: {
              enabled: false,
              custom: function(tooltipModel) {
                // Tooltip Element
                let tooltipEl = document.getElementById("chartjs-tooltip");

                // Create element on first render
                if (!tooltipEl) {
                  tooltipEl = document.createElement("div");
                  tooltipEl.id = "chartjs-tooltip";
                  tooltipEl.innerHTML = "<table></table>";
                  tooltipEl.style.backgroundColor = "rgba(0,0,0,0.71)";
                  tooltipEl.style.borderRadius = "5%";
                  document.body.appendChild(tooltipEl);
                }

                // Hide if no tooltip
                if (tooltipModel.opacity === 0) {
                  tooltipEl.style.opacity = 0;
                  return;
                }

                // Set caret Position
                tooltipEl.classList.remove("above", "below", "no-transform");
                if (tooltipModel.yAlign) {
                  tooltipEl.classList.add(tooltipModel.yAlign);
                } else {
                  tooltipEl.classList.add("no-transform");
                }

                function getBody(bodyItem) {
                  return bodyItem.lines;
                }

                // Set Text
                if (tooltipModel.body) {
                  let titleLines = tooltipModel.title || [];
                  let bodyLines = tooltipModel.body.map(getBody);

                  let innerHtml = "<thead>";

                  titleLines.forEach(function(title) {
                    innerHtml +=
                      '<tr><th style="color: white;">' + title + "</th></tr>";
                  });
                  innerHtml += "</thead><tbody>";

                  bodyLines.forEach(function(body, i) {
                    let colors = tooltipModel.labelColors[i];
                    let style = "background:" + colors.backgroundColor;
                    style += "; border-color:" + colors.borderColor;
                    style += "; border-width: 2px";
                    let span = '<span style="' + style + '"></span>';
                    innerHtml +=
                      '<tr><td style="color: white;">' +
                      span +
                      body +
                      "%" +
                      "</td></tr>";
                  });
                  innerHtml += "</tbody>";

                  let tableRoot = tooltipEl.querySelector("table");
                  tableRoot.innerHTML = innerHtml;
                }

                // `this` will be the overall tooltip
                let position = this._chart.canvas.getBoundingClientRect();

                // Display, position, and set styles for font
                tooltipEl.style.opacity = 1;
                tooltipEl.style.position = "absolute";
                tooltipEl.style.left =
                  position.left +
                  window.pageXOffset +
                  tooltipModel.caretX +
                  "px";
                tooltipEl.style.top =
                  position.top +
                  window.pageYOffset +
                  tooltipModel.caretY +
                  "px";
                tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                tooltipEl.style.fontSize = tooltipModel.bodyFontSize + "px";
                tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                tooltipEl.style.padding =
                  tooltipModel.yPadding + "px " + tooltipModel.xPadding + "px";
                tooltipEl.style.pointerEvents = "none";
              },
            },
            scales: {
              xAxes: [
                {
                  ticks: {
                    display: false,
                    beginAtZero: true,
                    max: 100,
                  },
                  scaleLabel: {
                    display: false,
                  },
                  gridLines: {
                    display: false,
                  },
                  stacked: true,
                },
              ],
              yAxes: [
                {
                  gridLines: {
                    display: false,
                  },
                  ticks: {
                    display: false,
                  },
                  stacked: true,
                },
              ],
            },
            legend: {
              position: "top",
              display: false,
            },
            animate: {},
            pointLabelFontFamily: "Quadon Extra Bold",
            scaleFontFamily: "Quadon Extra Bold",
            responsive: true,
            resizeDelay: 0,
            plugins: {
              datalabels: {
                formatter: function(value, context) {
                  if (value >= 3) return `${value}%`;
                  return "";
                },
                textAlign: "start",
              },
            },
          },
          data: {
            labels: ["Data 1"],
            datasets: [
              {
                label: "Dataset 1",
                data: [28],
                backgroundColor: ["#f4cdcd"],
              },
              {
                label: "Dataset 2",
                data: [45.7],
                backgroundColor: ["#facca5"],
              },
              {
                label: "Dataset 3",
                data: [65.9],
                backgroundColor: ["#fff2cc"],
              },
              {
                label: "Dataset 4",
                data: [72.4],
                backgroundColor: ["#d9ead3"],
              },
              {
                label: "Dataset 5",
                data: [32],
                backgroundColor: ["#c8d9f7"],
              },
            ],
          },
        };

        const sumData = data
          .map((x) => {
            if (x.SubGrupo) return x["countData"]["sum"];
            return 0;
          })
          .reduce((a, b) => a + b, 0);

        let datasets = [];
        // Función que ordena la data a un formato fijo
        const orderData = (p, d) => {
          const postion = (df) => {
            datasets[df] = d;
          };

          switch (p) {
            case "Riesgo muy alto":
              postion(0);
              break;
            case "Riesgo alto":
              postion(1);
              break;
            case "Riesgo medio":
              postion(2);
              break;
            case "Riesgo bajo":
              postion(3);
              break;
            case "Sin riesgo o riesgo despreciable":
              postion(4);
              break;
            case "Sin riesgo o riesgo bajo":
              postion(5);
              break;
            case "Muy alto":
              postion(0);
              break;
            case "Alto":
              postion(1);
              break;
            case "Medio":
              postion(2);
              break;
            case "Bajo":
              postion(3);
              break;
            case "Muy bajo":
              postion(4);
              break;
            default:
              datasets.push(d);
              break;
          }
          /*
          *
          * case 'Insatifacción muy alta':
              postion(0)
              break;
            case 'Insatifacción alta':
              postion(1)
              break;
            case 'Satifacción muy alta':
              postion(2)
              break;
            case 'Satifacción alta':
              postion(3)
              break;
            case 'Satifacción baja':
              postion(4)
              break;
          * */
        };

        data
          .filter((x) => x.SubGrupo)
          .map((x) => {
            const d = {
              label: "Dataset",
              data: [],
              backgroundColor: [],
              borderColor: [],
              borderWidth: 1,
            };
            const porcentage = this.calculatePorcentage(
              x["countData"]["sum"],
              sumData
            );
            const rango = this.rangoFp(
              x.SubGrupo,
              x.Grupo === "RGO-09-Engagement" ? 1 : 0
            );
            d.data.push(porcentage);
            d.label = x.SubGrupo;
            d.backgroundColor.push(rango.color);
            d.borderColor.push(rango.border);

            orderData(d.label, d);
          });

        dataHorizontalBar.data.labels = [label];
        dataHorizontalBar.data.datasets = datasets.filter((x) => {
          if (x) return true;
        });

        return dataHorizontalBar;
      }
      return this.horizontalBar;
    },
    validateDataGraph(data) {
      if (data) {
        let cont = 0;

        data.map((e) => {
          if (e.SubGrupo) cont++;
        });

        return !!cont;
      } else {
        return false;
      }
    },
    // Board
    showSubGroups(e, s = null) {
      if (!s) {
        if (!this.groups[e]) {
          this.efectos[e].active = !this.efectos[e].active;
        } else {
          this.groups[e].active = !this.groups[e].active;
        }
      } else {
        this.groups[e].sub2[s].active = !this.groups[e].sub2[s].active;
      }
    },
    recoverSubGroups() {
      const _this = this;

      const groups = this.groups;
      const efectos = this.efectos;
      // Se recuperan los subgrupos de cada variable principal
      for (const k in groups) {
        const el = _this.groups[k];
        if (k !== "intraLaborales") {
          _this.groups[k].sub = _this.getDataSubGroups(el.code, el.first);
        } else {
          for (const k2 in el.sub2) {
            const el2 = _this.groups[k].sub2[k2];
            _this.groups[k].sub2[k2].sub = _this.getDataSubGroups(
              el2.code,
              el2.first
            );
          }
        }
      }
      // Se recuperan los subgrupos de cada efecto
      for (const k in efectos) {
        const el = _this.efectos[k];
        _this.efectos[k].sub = _this.getDataSubGroups(el.code, el.first);
      }
    },
    getDataSubGroups(e, f) {
      return Object.keys(this.filteredData.dataAdmin)
        .filter((x) => {
          if (x.toLowerCase().indexOf(e.toLowerCase()) > -1 && x !== f) {
            return true;
          }
        })
        .map((x) => {
          return { first: x, title: x.substr(7, x.length) };
        });
    },
    getDataHeader() {
      const _this = this;
      // Datos del header
      let conData = _this.filteredData["dataAdmin"]["CONSENTIMIENTO"];
      let totalCurrent = conData ? conData[0]["countData"]["sum"] : 0;

      this.header = {
        date: _this.dateToString(_this.frsm["created"])
          ? _this.dateToString(_this.frsm["created"])
          : "Sin Fecha especificada",
        surveyed: totalCurrent,
      };
    },
    getDataInter(data, title) {
      if (data) {
        this.board.inter.data = { data: data, title };
        this.board.inter.data.group = data[0].Grupo;
        this.board.inter.active = true;
      }
    },
    closeMenuInter() {
      this.board.inter.active = false;
    },
    showCtx() {
      this.board.benchmark = !this.board.benchmark;
    },
    showDemo() {
      this.board.demo = !this.board.demo;
    },
    // Board - Historic
    getDataSelectHistoric() {
      let years = this.frsm.responses["AGR-year"].SubGrupo;
      if (years) {
        years = years.map((el) => parseInt(el));
        years.sort(function(a, b) {
          return b - a;
        });
        years = years.filter((e) => {
          if (e && e.toString() !== years[0].toString()) return true;
        });

        if (years.length > 0) this.board.historic.years = years;
      }
    },
    deleteSelectionHistoric() {
      this.board.historic.selectYear = "";
      this.selects.inputHistoric = "";
      this.board.historic.filter = null;
      this.board.historic.dataFilter = {};
      this.$refs.menuGroupsHistoric.restartSelects();
      // this.deselectFilter();
      this.$store.dispatch("notify", {
        message: `Histórico del tablero eliminado correctamente`,
        type: "is-link",
      });
    },
    getGroupsHistoric() {
      const historic = this.board.historic;
      return historic.selectYear
        ? historic.dataGroups[historic.selectYear]
        : [];
    },
    async setFilterHistoric(filter) {
      if (filter.length) {
        const newFilter = filter.map((x) => {
          return { gr: `AGR-${x.group}`, subgr: x.value };
        });
        const query = {
          filtro: [...newFilter],
          idfrs: this.frsm.id,
        };
        query.filtro.push({
          gr: "AGR-year",
          subgr: this.board.historic.selectYear.toString(),
        });
        this.board.historic.dataFilter = (
          await apiServices.post(`/filtroinformefrspublic`, query)
        ).data;
        this.board.historic.filter = newFilter;
        this.cambio ? (this.cambio = 0) : (this.cambio = 1);
      }
    },
    async deleteFilterHistoric() {
      if (this.board.filter && Object.keys(this.board.filter).length) {
        const query = {
          filtro: [...this.board.filter],
          idfrs: this.frsm.id,
        };
        query.filtro.push({
          gr: "AGR-year",
          subgr: this.board.historic.selectYear.toString(),
        });
        this.board.historic.dataFilter = (
          await apiServices.post(`/filtroinformefrspublic`, query)
        ).data;
      }
      this.board.historic.dataFilter = {};
      this.board.historic.filter = null;
      this.cambio ? (this.cambio = 0) : (this.cambio = 1);
    },
    // Table Groups
    async setFilterTable(newFilter) {
      if (newFilter.length) {
        try {
          // Set Filters
          const filters = newFilter.map((x) => {
            return { gr: `AGR-${x.name}`, subgr: x.subGrupo };
          });
          if (
            !this.board.filter ||
            JSON.stringify(filters) !== JSON.stringify(this.board.filter)
          ) {
            const query = {
              filtro: filters,
              idfrs: this.frsm.id,
            };
            const result = await apiServices.post(
              `/filtroinformefrspublic`,
              query
            );
            // console.log(result.data);
            this.board.dataAdmin = result.data;
            // Get data of historic
            if (this.board.historic.selectYear) {
              const query = {
                filtro: [...filters],
                idfrs: this.frsm.id,
              };
              query.filtro.push({
                gr: "AGR-year",
                subgr: this.board.historic.selectYear.toString(),
              });
              const resultFilter = await apiServices.post(
                `/filtroinformefrspublic`,
                query
              );
              this.board.historic.dataFilter = resultFilter.data;
            }
            this.board.filter = filters;
            await this.$store.dispatch("notify", {
              message: `Filtro aplicado al tablero`,
              type: "is-link",
            });
          }
        } catch (e) {
          await this.$store.dispatch("notify", {
            message: `Error al aplicar el filtro al tablero`,
            type: "is-danger",
          });
        }
      } else {
        this.board.filter = null;
        if (this.board.historic.filter) {
          this.board.historic.filter = null;
          this.$refs.menuGroupsHistoric.restartSelects();
        }
        await this.$store.dispatch("notify", {
          message: `Filtro eliminado correctamente`,
          type: "is-link",
        });
      }
    },
    deselectFilter() {
      this.$refs.tableFrsm.deselect();
    },
    deselectOne(filter) {
      this.$refs.tableFrsm.deselectOne([filter]);
    },
    // Helpers
    sortData(data, object = false) {
      if (data) {
        if (object) {
          data = data.filter((e) => {
            if (e.SubGrupo) {
              return true;
            }
            return false;
          });
          return data.slice().sort(function(a, b) {
            const nameA = a.SubGrupo.toUpperCase(); // ignore upper and lowercase
            const nameB = b.SubGrupo.toUpperCase(); // ignore upper and lowercase

            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          });
        }
        return data.slice().sort();
      }
      return data;
    },
    dateToString(d) {
      let date = new Date(d);
      let options = { year: "numeric", month: "long", day: "numeric" };
      date = date.toLocaleDateString(undefined, options);
      return date;
    },
    calculatePorcentage(v, sum) {
      return ((v * 100) / sum).toFixed(1);
    },
    rangoIntervencion(p, type = 0) {
      if (p) {
        let result = "";
        // Se suma todos los valores
        const sum = p
          .map((x) => {
            if (x.SubGrupo) return x["countData"]["sum"];
            return 0;
          })
          .reduce((a, b) => a + b, 0);

        // Objecto con estructura organizada
        let porcentageGroups = null;

        if (type === 0) {
          porcentageGroups = {
            alta1: {
              groups: ["Riesgo alto", "Riesgo muy alto", "Muy alto", "Alto"],
              sum: 0,
            },
            media: {
              groups: [
                "Riesgo medio",
                "Riesgo alto",
                "Riesgo muy alto",
                "Alto",
                "Muy alto",
                "Medio",
              ],
              sum: 0,
            },
            destacado: {
              groups: [
                "Sin riesgo o riesgo despreciable",
                "Riesgo bajo",
                "Sin riesgo o riesgo bajo",
                "Factor protector",
                "Bajo",
                "Muy bajo",
              ],
              sum: 0,
            },
          };
        } else if (type === 1) {
          porcentageGroups = {
            alta1: {
              groups: ["Bajo", "Muy bajo"],
              sum: 0,
            },
            media: {
              groups: ["Bajo", "Muy bajo", "Medio"],
              sum: 0,
            },
            destacado: {
              groups: ["Muy alto", "Alto"],
              sum: 0,
            },
          };
        }
        // Se saca la suma para la estrucutura solicitada
        p.map((e) => {
          const sub = !e.SubGrupo ? "" : String(e.SubGrupo);

          if (porcentageGroups.alta1["groups"].includes(sub)) {
            porcentageGroups.alta1.sum += parseFloat(
              this.calculatePorcentage(e["countData"]["sum"], sum)
            );
          }
          if (porcentageGroups.media["groups"].includes(sub)) {
            porcentageGroups.media.sum += parseFloat(
              this.calculatePorcentage(e["countData"]["sum"], sum)
            );
          }
          if (porcentageGroups.destacado["groups"].includes(sub)) {
            porcentageGroups.destacado.sum += parseFloat(
              this.calculatePorcentage(e["countData"]["sum"], sum)
            );
          }
        });

        // Se calcula el porcentage para cada elemento del objeto anterior y retornar un rango
        for (const k in porcentageGroups) {
          const porcentage = porcentageGroups[k]["sum"].toFixed(2);

          if (k === "alta1" && porcentage >= 30.0) {
            result = "bg-alta";
            break;
          } else if (k === "media" && porcentage >= 40.0) {
            result = "bg-media";
            break;
          } else if (k === "destacado" && porcentage >= 60.0) {
            result = "bg-destacado";
            break;
          } else if (porcentage < 30.0) {
            result = "bg-sinrango";
          }
        }
        return result;
      }
      return "bg-sinrango";
    },
    rangoFp: function(p, type = 0) {
      const rangos = {
        rango0: [
          "Riesgo muy alto",
          "Insatisfacción muy alta",
          "Presentación muy alta de sintomas",
          "Muy alto",
        ], // muy alta
        rango1: [
          "Riesgo alto",
          "Insatisfacción alta",
          "Presentación alta de sintomas",
          "Alto",
        ], // alta
        rango2: [
          "Riesgo medio",
          "Satisfacción muy alta",
          "Presentación media de sintomas",
          "Medio",
        ], // medio
        rango3: [
          "Riesgo bajo",
          "Satisfacción alta",
          "Presentación baja de sintomas",
          "Bajo",
        ], // bajo
        rango4: [
          "Sin riesgo o riesgo despreciable",
          "Sin riesgo o riesgo bajo",
          "Satisfacción baja",
          "Presentación muy baja de sintomas o sin presencia de ellos",
          "Muy bajo",
        ], // sin riesgo o muy bajo
      };
      if (rangos.rango0.includes(p)) {
        if (type === 1) {
          return {
            color: "#c8d9f7",
            border: "#a8c2ef",
          };
        }
        return {
          color: "#f4cdcd",
          border: "#f6adad",
        };
      } else if (rangos.rango1.includes(p)) {
        if (type === 1) {
          return {
            color: "#d9ead3",
            border: "#c3eab5",
          };
        }
        return {
          color: "#facca5",
          border: "#f6b884",
        };
      } else if (rangos.rango2.includes(p)) {
        return {
          color: "#fff2cc",
          border: "#f6db8a",
        };
      } else if (rangos.rango3.includes(p)) {
        if (type === 1) {
          return {
            color: "#facca5",
            border: "#f6b884",
          };
        }
        return {
          color: "#d9ead3",
          border: "#c3eab5",
        };
      } else if (rangos.rango4.includes(p)) {
        if (type === 1) {
          return {
            color: "#f4cdcd",
            border: "#f6adad",
          };
        }
        return {
          color: "#c8d9f7",
          border: "#a8c2ef",
        };
      } else {
        return {
          color: "#e1e1e1",
          border: "#c2c0c0",
        };
      }
    },
    // Others
    scrollTop() {
      const top = document.body.scrollHeight;
      window.scrollTo(top, 0);
    },
    createBodyTooltipInter(group) {
      if (this.interpretations[group.first]) {
        return `<div><h2 class='has-text-centered is-size-5 has-text-weight-bold'>${
          this.interpretations[group.first].title
        }</h2><br><p>${this.interpretations[group.first]["def"]}</p>${
          group.first !== "EFECTOS"
            ? "<br><span class='is-size-7 has-text-weight-bold'>Clic para ver más.</span>"
            : ""
        }</div>`;
      } else {
        return `<div><h2 class='has-text-centered is-size-5 has-text-weight-bold'>Error en los datos</h2><br><p>Por favor revisa que los datos estén correctos, posiblemente no se ingresó correctamente el nombre de la columna.</p><br><span class="has-text-weight-bold">Error en la columna ${group.first}</span></div>`;
      }
    },
    async copyLink(filter = null) {
      let textArea = document.createElement("textarea");

      textArea.style.position = "fixed";
      textArea.style.top = 0;
      textArea.style.left = 0;

      // Ensure it has a small width and height. Setting to 1px / 1em
      // doesn't work as this gives a negative w/h on some browsers.
      textArea.style.width = "2em";
      textArea.style.height = "2em";

      // We don't need padding, reducing the size if it does flash render.
      textArea.style.padding = 0;

      // Clean up any borders.
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";

      // Avoid flash of the white box if rendered for any reason.
      textArea.style.background = "transparent";

      let data = {};
      const allFilters = {
        board: this.board.filter,
        historic: this.board.historic.filter,
        yearHistoric: this.board.historic.selectYear,
      };
      filter = filter ? JSON.stringify(filter) : JSON.stringify(allFilters);

      const encodeFilter = btoa(filter); // Para descifrarlo es con atob()

      data.report = this.frsm.id;
      data.filter = btoa(encodeFilter); // Se vuelve a cifrar

      // let result = await apiServices.post('createviewclima', data);
      textArea.value =
        window.location.host + "/frp/share/" + data.report + "/" + data.filter;

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        let successful = document.execCommand("copy");
        let msg = successful ? "¡Copiado al portapapeles!" : "Error al copiar";
        let type = successful ? "is-link" : "is-danger";

        await this.$store.dispatch("notify", {
          message: msg,
          type: type,
        });
      } catch (err) {
        await this.$store.dispatch("notify", {
          message: "Error al copiar",
          type: "is-danger",
        });
      }
      document.body.removeChild(textArea);
    },
    async downloadReport() {
      try {
        await this.$nextTick();
        if (this.board.historic.selectYear) this.deleteSelectionHistoric();
        if (this.board.filter) this.deselectFilter();
        this.$refs.pdfFrp.downloadPdf();
      } catch (err) {
        console.error("Error downloading PDF:", err);
      }
    },
    handleScrollFilters() {
      const divObserver = document.getElementById("divObserver");

      const observer = new IntersectionObserver(
        ([e]) => {
          const stickyDiv = document.getElementById("divFilters");
          if (
            e.intersectionRatio < 1 &&
            (this.board.filter || this.board.historic.filter) &&
            !this.board.demo
          ) {
            stickyDiv.classList.add("divFilter-isSticky");
          } else {
            if (
              stickyDiv &&
              stickyDiv.classList.contains("divFilter-isSticky")
            ) {
              stickyDiv.classList.remove("divFilter-isSticky");
            }
          }
        },
        { threshold: [1] }
      );
      observer.observe(divObserver);
    },
  },
  mounted() {
    this.handleScrollFilters();
  },
  created() {
    if (this.idtoken) {
    }
  },
  components: {
    yGraph,
    tableR,
    menuInterpretacion,
    Demographic,
    Benchmark,
    menuFiltersHistoric,
    CardProfessional,
    Pdf,
  },
  beforeMount: async function() {
    if (window.location.host === "localhost:8080") {
      console.log(this.frsm);
    }
    const _this = this;

    if (!this.isOculto) {
      this.$store.commit("ocultarSide");
    }

    if (!this.$route.params.id) {
      try {
        // Se recuperan todos los grupos calculados
        const result = await apiServices.get(`/groupsfrp/${_this.frsm.id}`);
        if (result.data) {
          _this.table.data = result.data;
          _this.table.limitSelection = Object.keys(result.data).length;
        }
        /* if (window.location.host === "localhost:8080"){
          console.log(result.data)
        } */
      } catch (e) {
        console.log(e);
      }
    } else {
      if (this.frsm.newFilter) {
        const newFilter = this.frsm.newFilter;
        this.board.dataAdmin = newFilter;
        this.board.filter = newFilter.allFilters["board"];
        if (newFilter.allFilters["historic"])
          this.board.historic.filter = newFilter.allFilters["historic"];
        if (parseInt(newFilter.allFilters["yearHistoric"]))
          this.selects.inputHistoric = parseInt(
            newFilter.allFilters["yearHistoric"]
          );
      }
    }

    _this.recoverSubGroups();
    _this.getDataHeader();
    _this.getDataSelectHistoric();
  },
  errorCaptured(err, vm, info) {
    console.log({ err, vm, info });
    /* this.$store.dispatch("notify", {
      message: `Hubo un error al cargar el Tablero, intenta de nuevo o reporta este error`,
      type: "is-danger",
    }); */
  },
  watch: {
    "board.filter": function(nv) {
      if (!this.$route.params.id) {
        this.closeMenuInter();
        this.recoverSubGroups();
        this.getDataHeader();
        this.cambio ? (this.cambio = 0) : (this.cambio = 1);
        // this.scrollTop()
      }
    },
    "selects.inputHistoric": async function(nv) {
      const _this = this;
      const year = nv;
      if (year !== "") {
        try {
          // Válida si los datos ya están guardados, si es asi los retorna rapidamente
          if (
            _this.board.historic.dataAdmin[year] &&
            _this.board.historic.dataGroups[year] &&
            !(this.board.filter && Object.keys(this.board.filter).length)
          ) {
            _this.board.historic.selectYear = year.toString();
            await this.$store.dispatch("notify", {
              message: `Histórico aplicado al tablero`,
              type: "is-link",
            });
            this.cambio ? (this.cambio = 0) : (this.cambio = 1);
            // this.table.limitSelection = 2;
          } else {
            const result = await apiServices.get(
              `/groupsfrp/${_this.frsm.id}/${year}`
            );
            if (result.data) {
              const dataAdmin = result.data.filter((e) => {
                if (e.name === "year" && e.subGrupo === year.toString())
                  return true;
              })[0];
              if (dataAdmin) {
                _this.board.historic.selectYear = year.toString();
                _this.board.historic.dataAdmin[year] = dataAdmin;
                _this.board.historic.dataGroups[year] = result.data
                  .map((x) => {
                    return { value: x.subGrupo, active: false, group: x.name };
                  })
                  .filter((x) => x.value !== "null" && x.group !== "year");

                if (
                  this.board.filter &&
                  Object.keys(this.board.filter).length
                ) {
                  const query = {
                    filtro: [...this.board.filter],
                    idfrs: this.frsm.id,
                  };
                  query.filtro.push({ gr: "AGR-year", subgr: year.toString() });
                  _this.board.historic.dataFilter = (
                    await apiServices.post(`/filtroinformefrspublic`, query)
                  ).data;
                }

                await this.$store.dispatch("notify", {
                  message: `Histórico aplicado al tablero`,
                  type: "is-link",
                });

                this.cambio ? (this.cambio = 0) : (this.cambio = 1);
                // this.table.limitSelection = 2;
              } else {
                throw new Error(
                  "¡Ups! No se pudo extraer los Datos principales"
                );
              }
            }
          }
        } catch (e) {
          this.board.historic.selectYear = "";
          this.selects.inputHistoric = "";
          await this.$store.dispatch("notify", {
            message: `Error al aplicar el histórico al tablero`,
            type: "is-danger",
          });
          console.log(e);
        }
      }
    },
  },
};
</script>

<style lang="scss">
// Range 1
.bg-muyAlto {
  background-color: #f4cdcd;
  border: solid 1px #f6adad;
}
.bg-alto {
  background-color: #facca5;
  border: solid 1px #f6b884;
}
.bg-bajo {
  background-color: #d9ead3;
  border: solid 1px #c3eab5;
}
.bg-noRiesgo {
  background-color: #c8d9f7;
  border: solid 1px #a8c2ef;
}
// Range 1.1
.bg-muyAltoEng {
  background-color: #c8d9f7;
  border: solid 1px #a8c2ef;
}
.bg-altoEng {
  background-color: #d9ead3;
  border: solid 1px #c3eab5;
}
.bg-bajoEng {
  background-color: #facca5;
  border: solid 1px #f6b884;
}
.bg-noRiesgoEng {
  background-color: #f4cdcd;
  border: solid 1px #f6adad;
}
// Range 2
.bg-alta {
  background-color: #f4cdcd;
  border: solid 1px #f6adad;
}
.bg-media {
  background-color: #fff2cc;
  border: solid 1px #f6db8a;
}
.bg-destacado {
  background-color: #d9ead3;
  border: solid 1px #c3eab5;
}
.bg-sinrango {
  background-color: #eceeec;
  border: solid 1px #d4d5d3;
}
// Color icons
.bg-alta .icon-dash {
  background-color: #f6adad;
  border-radius: 50%;
}
.bg-media .icon-dash {
  background-color: #f6db8a;
  border-radius: 50%;
}
.bg-destacado .icon-dash {
  background-color: #c3eab5;
  border-radius: 50%;
}
.bg-sinrango .icon-dash {
  background-color: #d4d5d3;
  border-radius: 50%;
}
// Table
#table-1 {
  border-collapse: collapse;
  border-radius: 1em;
  overflow: hidden;
}
#table-2 {
  border-collapse: collapse;
  border-radius: 1em;
  overflow: hidden;
}
#table-1 tr {
  width: 100% !important;
  text-align: center !important;
}
#table-2 tr {
  width: 100% !important;
  text-align: center !important;
}

.border {
  border-collapse: collapse;
  border-radius: 1em;
  overflow: hidden;
}

.message {
  background-color: #fafafa;
}

.is-blue {
  background-color: #a8c2ef !important;
  color: white !important;
}

.titleC {
  text-overflow: ellipsis !important;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  display: inline-block;
  text-transform: initial;
}

.contentTooltipInter {
  max-width: 20% !important;
  min-width: 10% !important;
}

.contentTooltipRangeInter {
  max-width: 30% !important;
  min-width: 10% !important;
  text-align: center !important;
}

.content-historic {
  margin-top: -45px;
  opacity: 0.5;
}
.content-historic .titleC {
  font-size: 14px !important;
}
.content-historic .material-icons {
  font-size: 18px !important;
}

.content-nodata-graph {
  width: 100%;
  padding: 5px;
  font-weight: bold;
  margin-top: 1%;
  margin-bottom: 1%;
  margin-left: 0.6%;
}
.content-nodata-graph span {
  justify-content: center;
}
.content-nodata-graph .material-icons {
  margin: auto 0 auto 0;
}

.divFilter-isSticky {
  background-color: white;
  position: -webkit-sticky;
  position: sticky;
  z-index: 55;
  padding: 10px 5px;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
  border-radius: 6px;
}

.divFilter-isSticky .field.is-grouped.is-grouped-multiline {
  flex-wrap: nowrap !important;
  overflow-x: auto;
  scrollbar-width: thin;
}

.divFilter-isSticky::-webkit-scrollbar {
  width: 2px !important;
  height: 2px !important;
}

.divFilter-isSticky .field.is-grouped.is-grouped-multiline .control {
  margin-bottom: 0;
}

.myObserver {
  height: 15px;
  width: 100%;
  pointer-events: none;
  position: relative;
  top: auto;
  z-index: -1;
  overflow: hidden;
}

.tooltip {
  z-index: 55 !important;
}

.title-card {
  border-radius: 10px !important;
  background-color: #f3f3f3 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/frpm/Resultados.vue